import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../../../property';
import { AlertService } from '../../../../../_services';
import { ApiResponse } from '../../../../../_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { BathroomService } from '../../bathroom.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-bathroom-form',
    templateUrl: './bathroom-form.component.html',
    styleUrls: ['./bathroom-form.component.css'],
    standalone: false
})
export class BathroomFormComponent implements OnInit
{



	constructor(private router: Router,
		private activatedRoute: ActivatedRoute,
		private bathroomService: BathroomService,
		private featureService: FeatureService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data)
	{
		this.shortTermRentalId = data.shortTermRentalId;
	}


	@Input() shortTermRentalId: number;
	@Input() featuresList = [];
	@Input() bathroom: any;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	apiResponse: ApiResponse;

	bathroomId: number;


	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	formAlert: String;
	formTitle: String;

	bathroomNames = [
		{ value: 'BA1', name: 'Bathroom 1 (Master)' },
		{ value: 'BA2', name: 'Bathroom 2' },
		{ value: 'BA3', name: 'Bathroom 3' },
		{ value: 'BA4', name: 'Bathroom 4' },
		{ value: 'BA5', name: 'Bathroom 5' },
		{ value: 'BA6', name: 'Bathroom 6' },
		{ value: 'BA7', name: 'Bathroom 7' },
		{ value: 'BA8', name: 'Bathroom 8' },
		{ value: 'BA9', name: 'Bathroom 9' },
		{ value: 'BA10', name: 'Bathroom 10' },
		{ value: 'BA11', name: 'Bathroom 11' },
		{ value: 'BA12', name: 'Bathroom 12' },
	];

	bathroomTypes = [
		{ value: 'FU', name: 'Full - Sink, Toilet, Shower, Tub' },
		{ value: 'TQ', name: '3/4 - Sink, Toilet, Shower' },
		{ value: 'TT', name: '3/4 - Sink, Toilet, Tub' },
		{ value: 'HA', name: 'Half - Sink and Toilet' }
	];

	accessVias = [
		{ value: 'HA', name: 'Hall' },
		{ value: 'BD', name: 'Bedroom' },
		{ value: 'HB', name: 'Hall and Bedroom' },
		{ value: 'GA', name: 'Garage' },
		{ value: 'OU', name: 'Outside' },
		{ value: 'OT', name: 'Other' },

	];


	validationMessages = {
		'bathroomId': [],
		'shortTermRentalId': [],
		'name': [],
		'bathroomType': [],
		'description': [],
		'consumablesDesc': [],
		'accessVia': [],
		'showerDisabledAccess': [],
		'tubDisabledAccess': [],
	};

	ngOnInit()
	{
		this.formBuild();
		if (this.bathroom)
		{
			this.form1.patchValue(this.bathroom);
			this.bathroomId = this.bathroom.bathroomId;
		}
	}


	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;
			this.bathroomService.add(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.bathroom = res.data.bathroom;
						this.doAdd.emit(this.bathroom);

					},
					err =>
					{
						console.log('bathroom-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}


	formUpdate()
	{
		console.log('bathroom: ' + JSON.stringify(this.form1.value));
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}
			this.formLoading = true;

			this.bathroomService.update(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.bathroom = res.data.bathroom;
						this.doUpdate.emit(this.bathroom);
					},
					err =>
					{
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;

			this.bathroomService.delete(this.bathroom.bathroomId)
				.subscribe(
					res =>
					{
						console.log('bathroom-delete SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.doDelete.emit(this.bathroom);
					},
					err =>
					{
						console.log('bathroom-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formBuild()
	{
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.form1 = this.formBuilder.group({

			bathroomId: [this.bathroomId],
			shortTermRentalId: [this.shortTermRentalId],
			name: ['', Validators.required],
			bathroomType: ['', Validators.required],
			description: [''],
			consumablesDesc: [''],
			accessVia: ['', Validators.required],
			showerDisabledAccess: [''],
			tubDisabledAccess: [''],
		});
	}
}
